// src/Components/Settings/SettingsRow.jsx
// Web port of mobile's SettingsRow.tsx: icon-in-box, title/subtitle, and a
// right-side slot for a value string, a custom element, and/or a chevron.
import React from "react";
import { ChevronRight, Loader2 } from "lucide-react";

const SettingsRow = ({
  title,
  subtitle,
  value,
  valueColor,
  icon: Icon,
  iconColor = "text-brand-accent",
  onClick,
  rightElement,
  showChevron = true,
  loading = false,
  disabled = false,
  destructive = false,
}) => {
  const isInteractive = typeof onClick === "function" && !disabled;

  return (
    <button
      onClick={isInteractive ? onClick : undefined}
      disabled={!isInteractive}
      className={`w-full flex items-center gap-3 px-4 py-3.5 border-b border-brand-borderLight last:border-b-0 text-left transition-colors ${
        isInteractive ? "hover:bg-brand-accentMuted" : ""
      } ${disabled ? "opacity-50" : ""}`}
    >
      {Icon && (
        <div className="w-8 h-8 rounded-lg bg-brand-iconBg flex items-center justify-center flex-shrink-0">
          <Icon size={16} className={iconColor} />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-semibold ${destructive ? "text-brand-accent" : "text-brand-text"}`}>
          {title}
        </p>
        {subtitle && <p className="text-xs text-brand-textSecondary mt-0.5">{subtitle}</p>}
      </div>
      {loading ? (
        <Loader2 size={16} className="animate-spin text-brand-textSecondary" />
      ) : (
        <>
          {value && (
            <span className={`text-sm ${valueColor || "text-brand-textSecondary"}`}>{value}</span>
          )}
          {rightElement}
          {showChevron && isInteractive && !rightElement && (
            <ChevronRight size={16} className="text-brand-placeholder" />
          )}
        </>
      )}
    </button>
  );
};

export default SettingsRow;
